import {Tabs} from 'antd'
import {feed_fetchFeedByContainer_Api, post_getPosts_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import EmptyHolder from 'components/EmptyHolder'
import Pure from 'components/Pure'
import {useQueryString} from 'hooks'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import {permissionCodes} from 'modules/permissions/contants'
import PermissionProvider from 'modules/permissions/PermissionProvider'
import React, {useCallback, useContext, useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {nest} from 'recompose'
import {feedContentTypes} from 'views/Feed/Feed'
import {FaFilter} from 'react-icons/fa6'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {renderFeedByType} from '../../../MainPage/functions/renderFeedItem'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {getRouteSearchParams} from '../../../../envs/_current/history'
import GeneralPostForm from '../../../../components/Feed/PostForm/GenericPostForm'
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {LazyPagination} from "../../../../modules/asyncCache/components/LazyPagination";

const OrganizationNews = ({ Wrapper = 'div', sample, Footer = NullAsDefault }) => {
    const t = useTranslate()
    const {isLg, isSm} = useContext(LayoutContext)
    const location = useLocation()
    const [queryString] = useQueryString()
    const content_type = _.get(queryString, 'content-type')
    const { organization } = useContext(OrganizationContainerContext)

    const [id, prop] = [getId(organization), getType(organization)]
    const apiInfo = feed_fetchFeedByContainer_Api

    const refreshKey = useMemo(
        () => [
            apiInfo.path.replace(':id', id).replace(':prop', prop),
            content_type,
            `refreshToken=${location?.state?.refreshToken}`,
        ].join('/'),
        [id, prop, apiInfo, content_type, location?.state]
    )

    const renderTopFeeds = useCallback(
        () => (
            <LazyPagination
                onDone={() => true}
                key={content_type}
                renderEmpty={NullAsDefault}
                renderLoading={NullAsDefault}
                PaginationMeta={NullAsDefault}
                apiInfo={post_getPosts_Api}
                values={{pinned: 1, content_type}}
                renderItem={renderFeedByType(content_type)}
                query={bindQueryParams([{id: id}, {prop: prop}])}
                // renderWrap={(children) => children && (
                //     <div className="flex flex-col gap-3">
                //         <span className="font-medium text-xs text-slate-500 tracking-wide">
                //             {t('pined post')}
                //         </span>
                //         {children}
                //     </div>
                // )}
            />
        ),
        [content_type, id, prop]
    )

    if (_.isEmpty(organization)) return null

    const { available_actions } = organization

    return (
        <Wrapper className="space-y-3">
            <PermissionProvider
                permissions={{
                    [permissionCodes.canPost]: _.get(available_actions, permissionCodes.canPost),
                }}>
                <GeneralPostForm
                    container={{ type: getType(organization), id: getId(organization) }}
                    defaultChannel={organization?.default_channel}
                />
            </PermissionProvider>

            {/*{renderTopFeeds()}*/}

            <NavigationContext.Consumer>
                {({ history }) => (
                    <div className="flex items-baseline md:items-center gap-1 min-w-0">
                        {/* Bỏ hẳn label trên mobile - đỡ tốn bề ngang cho hàng tab vốn đã nhiều mục,
                            desktop vẫn giữ vì đủ chỗ. */}
                        {!isSm && (
                            <span className="flex-shrink-0 text-slate-400" title={t('filters by')}>
                                <FaFilter size={12}/>
                            </span>
                        )}
                        {/* min-w-0 + overflow-x-auto - trước đây Tabs là flex item không có giới hạn
                            bề rộng riêng nên tràn khỏi màn hình thay vì tự cuộn ngang (đã gặp thực tế
                            hàng tab "Tất cả/Bài viết/Tin tức/Hỏi đáp/Thăm dò..." bị overflow). */}
                        <div className="flex-1 min-w-0 overflow-x-auto">
                            <Tabs
                                className="tab-news-inner"
                                activeKey={content_type}
                                tabBarStyle={{ margin: 0 }}
                                destroyOnHidden={true}
                                onChange={(activeKey) => {
                                    const searchParams = getRouteSearchParams()
                                    searchParams.set('content-type', activeKey)
                                    history.push({ search: '?' + searchParams.toString() })
                                }}
                                items={feedContentTypes.map(({ label, value }) => ({
                                    key: value,
                                    label: <span className="space-x-1 whitespace-no-wrap">{t(label)}</span>,
                                }))}
                            />
                        </div>
                    </div>
                )}
            </NavigationContext.Consumer>

            <Pure input={[id, prop, content_type, refreshKey]}>
                <EntityList
                    // sample={sample}
                    key={refreshKey}
                    values={{ content_type }}
                    apiInfo={apiInfo}
                    query={bindQueryParams([{ id }, { prop }])}
                    renderItem={renderFeedByType(content_type || 'all')}
                    renderEmpty={() => (
                        <div className="w-full justify-center items-center">
                            <EmptyHolder />
                        </div>
                    )}
                    renderWrap={(child, __, count) => (
                        <div className="space-y-3">
                            {child}
                            {count ? <Footer /> : null}
                        </div>
                    )}
                />
            </Pure>
        </Wrapper>
    )
}

export default nest(Pure, OrganizationNews)